import Vue from 'vue';
import Card from 'src/components/Card/Card';
import GenericTable from './GenericTable.vue';
import { invokeOrFalse } from 'src/utils';
import Dialog from 'src/components/GenericDialog/GenericDialog.vue';
import callRefFunc from 'src/utils/callRefFunc';
export default Vue.extend({
    components: { Card, GenericTable, Dialog },
    props: {
        tableProps: { type: Object, required: true },
        dialogHeaderProp: { type: String },
        callbackToExecuteUponCloseProp: { type: Function },
        qDialogProps: { type: Object }
    },
    computed: {
        dialogProps() {
            return {
                qDialogProps: this.qDialogProps
            };
        }
    },
    methods: {
        closeDialog() {
            callRefFunc(this, 'dialogComponent', 'close');
            invokeOrFalse(this.callbackToExecuteUponCloseProp);
        },
        openDialog() {
            callRefFunc(this, 'dialogComponent', 'open');
        }
    }
});
